<template>
  <div class="uploading-page">
    <div class="img-box">
      <h1 :title="content !== null ? content : 'Uploading'/* ___ */">{{ content !== null ? content : 'Uploading'/* ___ */ }}</h1>
      <img :src="require('@/assets/images/loading.svg')" alt="">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      default: () => ''
    }
  }
}
</script>
